import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from "./Dropdown";
const buttonGroupVariants = cva("inline-flex w-fit items-stretch", {
    variants: {
        orientation: {
            horizontal: "flex-row",
            vertical: "flex-col",
        },
        removeGaps: {
            true: "",
            false: "gap-2",
        },
    },
    compoundVariants: [
        {
            orientation: "horizontal",
            removeGaps: true,
            className: cn("gap-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [GEN12] — needs cleanup
            "[&>*:not(:first-child)]:rounded-l-none!", "[&>*:not(:first-child)]:border-l-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [GEN12] — needs cleanup
            "[&>*:not(:last-child)]:rounded-r-none!"),
        },
        {
            orientation: "vertical",
            removeGaps: true,
            className: cn("gap-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [GEN12] — needs cleanup
            "[&>*:not(:first-child)]:rounded-t-none!", "[&>*:not(:first-child)]:border-t-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [GEN12] — needs cleanup
            "[&>*:not(:last-child)]:rounded-b-none!"),
        },
    ],
    defaultVariants: {
        orientation: "horizontal",
        removeGaps: true,
    },
});
const ButtonGroup = React.forwardRef(({ className, orientation = "horizontal", removeGaps = true, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, role: "group", "data-orientation": orientation, className: cn(buttonGroupVariants({ orientation, removeGaps }), className), ...props }));
});
ButtonGroup.displayName = "ButtonGroup";
function ButtonGroupDropdown({ trigger, items, align = "center", onOpenChange, }) {
    return (React.createElement(DropdownMenu, { onOpenChange: onOpenChange },
        React.createElement(DropdownMenuTrigger, { asChild: true }, trigger),
        React.createElement(DropdownMenuContent, { align: align }, items.map((item, index) => (React.createElement(DropdownMenuItem, { key: index, ...item }))))));
}
export { ButtonGroup, ButtonGroupDropdown, buttonGroupVariants };
//# sourceMappingURL=ButtonGroup.js.map